var _effectorFileName = "/builds/gmini/front-ui-kit/src/NotifyButton/NotifyButton.styled.ts";
import styled from 'styled-components';
import { IconButton } from '../IconButton';
export const Inner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 24px;
  height: 24px;
`;
export const Dot = styled.div`
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d9575e;
  top: 2px;
  right: 0;
`;
export const Button = styled(IconButton)`
  ${props => props.selected && 'background: rgba(53, 59, 96, 0.2);'};

  & path {
    fill: rgba(53, 59, 96, 0.5);
  }

  &:hover {
    background: rgba(53, 59, 96, 0.1);
  }

  &:active {
    background: rgba(53, 59, 96, 0.2);
  }
`;